module.exports = __webpack_public_path__ + "img/logo_login.4f31ea8a.png";